// extracted by mini-css-extract-plugin
export default {"header":"PasswordView_header__l-D1Q","referral":"PasswordView_referral__BjmuZ","referralText":"PasswordView_referralText__s+iNg"};